import { shouldInjectRealtimeStatusEvent } from './realtime-voice-agent';

export const LIVE_VOICE_BILLING_FAILED_PREFIX =
  'realtime-status-billing_failed-';

export function shouldProcessLiveVoiceStatus(args: {
  event: { turnId: string; sessionId?: string; createdAt?: number };
  lastSeenEventId: string | null;
  activeLeaseSessionId: string | null;
  callLeaseSessionId: string | null;
  callOpenedAt: number | null;
}): boolean {
  const billingFailure = args.event.turnId.startsWith(
    LIVE_VOICE_BILLING_FAILED_PREFIX
  );
  if (billingFailure && !args.event.sessionId) return false;
  // The provider may close before Convex delivers its billing failure. Retain
  // this call's identity for that terminal status, but never for ordinary work.
  const sessionId =
    args.activeLeaseSessionId ??
    (billingFailure ? args.callLeaseSessionId : null);
  return (
    shouldInjectRealtimeStatusEvent(
      args.event.turnId,
      args.lastSeenEventId,
      args.event.sessionId,
      sessionId
    ) &&
    !(
      args.callOpenedAt !== null &&
      args.event.createdAt !== undefined &&
      args.event.createdAt < args.callOpenedAt
    )
  );
}
